module.exports = __webpack_public_path__ + "img/Fanions.d963cb9.jpg";